<template>
<div>
<section class="page-title">        
    <v-img 
        v-if="this.$vuetify.breakpoint.lg"
        height="320px"        
        :src="require('@/Content/images/banner1.jpg')"
        class="white--text"
        gradient="to right, rgba(255, 255, 255, 0.5), rgba(196, 233, 255, 0.2)"
        max-width="100%"  
        position="center top"        
      >
      <div class="center">
        <p class="label-planos" >Pessoa Física</p>
        <h1 class="the-title"><span>Soluções</span> para você</h1>
        <p style="color:#666">Temos o plano certo para cuidar da saúde bucal de toda a família!</p>
        <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
    </div>
    </v-img>
    <v-img 
        v-else
        height="300"        
        class="white--text"
        gradient="to right, rgba(255, 255, 255, 0.5), rgba(196, 233, 255, 0.2)"
        max-width="100%"  
        position="center top"        
      >
      <div class="center">
        <p class="label-planos" >Pessoa Física</p>
        <h1 class="the-title"><span>Soluções</span> para você</h1>
        <p style="color:#7593b4">Dê o primeiro passo e garanta um sorriso saudável</p>
        <a @click="scrollToClass('.contrataragora')" class="button-contrate">Contratar Agora</a>
    </div>
    </v-img>
</section>


<section class="page-content center">
    <p class="title-label">A Oral Santa Helena</p>
    <p>Toda evolução é feita de escolhas e a Oral Santa Helena optou pela qualidade. Fundada em 2001 por cirurgiões-dentistas, a empresa oferece soluções completas em assistência odontológica, tratando o cliente com carinho e dedicação.</p>
    <p>Para nós, garantir excelência em atendimento é a maior prova de respeito que podemos dar a quem nos confia a sua saúde.</p>
    <p>Nosso compromisso é assistir cada cliente de maneira especial.</p>
    <p>Conheça nossos Planos Assistenciais e garanta mais saúde e qualidade de vida para você e sua família.</p>
    <p class="title-label">Por que comprar um plano Oral Santa Helena?</p>
    <p>A Oral Santa Helena tem planos atrativos, flexíveis e acessíveis para você e sua família, confira:</p>
    <p ><strong>Agilidade</strong> -  Adesão rápida, sem burocracia, tratamentos com autorização online para a maioria dos procedimentos, Carteirinha virtual e Rede credenciada na palma de sua mão.</p>
    <p><strong>Referência em qualidade</strong> -  Nossos Planos foram classificados pelo Instituto Pró-Teste como alguns dos melhores planos odontológicos do Brasil, sendo que o Plano Ortodonzia foi considerado o melhor do Teste!</p>
    <p><strong>Ampla elegibilidade</strong> - Adesão extensiva ao grupo familiar.</p>
    <p><strong>Atendimento personalizado</strong> - Portal na Internet, área restrita ao beneficiário, Call Center e redes sociais.</p>
    <p><strong>Rede Credenciada</strong> -  Ampla rede credenciada com dentistas em todo o Brasil, acesso online à lista de dentistas credenciados, 24 horas com o conforto e a comodidade do smartphone.</p>
    <p><strong>Desconto em Farmácia</strong> -  Através da rede de drogarias credenciadas, os beneficiários Oral Santa Helena receberão descontos em vários medicamentos, e ainda descontos em produtos de higiene, entre outras.</p>
    <p class="title-label">Quem pode aderir?</p>
    <p>O plano ofertado é individual/familiar, podendo ser adquirido por qualquer pessoa.</p>
    <p class="title-label">Principais Coberturas (Rol da ANS)</p>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico), radiografia panorâmica;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Próteses</strong> - Ajuste oclusal, Coroa provisória com e sem pino, Coroa total em cerômero, Coroa total metálica, Núcleo de preenchimento, Núcleo metálico fundido, Pino pré-fabricado, Remoção de trabalhos protéticos, Restauração metálica fundida;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <!-- <span class="icon"></span> -->
        <p><strong>Ortodontia</strong> -  Documentação ortodôntica, Instalação e manutenção de aparelho metálico fixo (Verificar planos que incluem esta cobertura);</p>
    </div>
    <div >
        <!-- <span class="icon"></span> -->
        <p><strong>Implantes</strong> - Implantes Unitários, Coroa metalo-cerâmica sobre implantes, Prótese Protocolo total híbrida sobre Implantes (verificar planos que incluem esta cobertura);</p>
    </div>
    <!-- <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.Oral Santa Helena.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
    </div> -->
    <p class="title-label">Carências</p>
    <p>Somente alguns planos da Oral Santa Helena possuem carências. Carência é o prazo ininterrupto, em que o beneficiário não goza do direito de utilizar da cobertura do plano contratado, sendo este prazo contado da data de aceitação da Proposta de Adesão, que está entendida data de início de vigência do beneficiário.</p>
    <!-- <table class="table-carencia" cellpadding="0" cellspacing="0" border="0">
        <tr>
            <th></th>
            <th colspan="1">Carências</th>
        </tr>
        <tr class="mini-header">
            <td>Procedimentos</td>

            <td class="carencia">Plano Individual/Familiar</td>
        </tr>
        <tr>
            <td>Consulta de Urgência</td>

            <td class="carencia">24 horas</td>
        </tr>
        <tr>
            <td>Consulta inicial, Radiologia, Prevenção</td>

            <td class="carencia">30 dias</td>
        </tr>
        <tr>
            <td>Odontopediatria, Periodontia, Dentística, Cirurgia Oral Menor</td>

            <td class="carencia">60 dia</td>
        </tr>
        <tr>
            <td>Endodontia</td>

            <td class="carencia">120 dias</td>
        </tr>
        <tr>
            <td>Prótese</td>

            <td class="carencia">180 dias</td>
        </tr>
    </table> --> 
    <div class="contrataragora"> 
    <v-fade-transition mode="out-in">    
    <div class="exibelocalizacao" v-if="exibeLocalizacao"> 
    <div class="planos-wrapper">
    <p class="planos-title">Local de utilização</p>
    <v-layout align-center>
    <v-flex xs12 sm12>
        <v-card
            flat
            max-height="400px"
            max-width="600px"
            class="mx-auto localizacao"
            style="border: 1px solid; border-color: #00B21E;border-radius: 10px;">
            <v-card-text>
                <v-container grid-list-md>
                <v-layout align-center justify-center row wrap>
                <v-flex xs12 sm12 lg10>
                <v-select
                id="comboOrgao"               
                v-model="abrangenciaAgrupamento"
                item-value="abrangenciaId"
                item-text="agrupamento"
                :items="agrupamentosUF"
                label="Local de Utilização"                
                ></v-select>
                </v-flex>
                <v-layout align-center justify-center row wrap>
                <v-flex xs12 sm6 md6 lg6 >
                <v-btn
                style="border-radius: 6px;"
                large                
                dark
                @click="controlaExibicaoPlanos()"
                color="#00B21E"
                >Consultar Planos</v-btn>
                </v-flex>
                </v-layout>
                </v-layout>
                </v-container>
            </v-card-text>
        </v-card>
    </v-flex>
    </v-layout>
    </div>
    </div>
    <div class="exibeplanos" v-else>
    <p class="title-label">Investimento</p>
    <p>O investimento abaixo no plano odontológico é valor unitário da mensalidade que o Responsável Financeiro paga para a operadora.</p>
    <div class="planos-wrapper">
    <p class="planos-title">Região:  {{this.nomeAgrupamento}}
        <v-btn
        icon        
        dark
        @click.prevent="exibeLocalizacao = !exibeLocalizacao"
        color="#00B21E"
        >
        <v-icon style="margin-right: 0%;">cached</v-icon>
        </v-btn>
        </p>
        <!-- <p class="planos-title">INDIVIDUAL ANUAL</p> -->
        <v-container
            grid-list-md
            >
        <v-layout row wrap justify-center>
                <v-flex
                v-for="plano in planos" :key="`3${plano.id}`" xs12 sm12 md12 lg4              
                >
                <div class="list-planos">                    
                    <div class="item">
                        <!-- <h6 class="dePara">De</h6>
                        <p class="priceOld"><span>R$</span> {{plano.oldValue}}<br></p>
                        <h6 class="dePara">Por</h6> -->
                        <p class="price" v-if="plano.qualificacao == 'Individual'"><span>R$</span> {{plano.value}}<br><span>(Por pessoa)</span></p>
                        <p class="price" v-else><span>R$</span> {{plano.value}}<br><span>(Até 4 pessoas)</span></p>
                        <!-- <h6 class="desconto">Desconto especial de R$ {{calculaDesconto(plano)}}</h6> -->
                        <p class="cobertura">
                            <span>
                                <p class="cobertura"><span>{{plano.area_atuacao}}</span><b>{{plano.qualificacao}}</b></p>
                            </span>
                        </p>
                        <div style="height: 52px;" v-if="plano.typePayment == 'CARTAO'" class="boleto">
                        <span><v-img 
                            max-height="20px"        
                            :src="require('@/Content/images/cartoes.png')"
                            max-width="60%"
                            style="margin-left: 50px;" />
                        </span>
                        <v-icon style="margin-top: 2px;">credit_card</v-icon>
                        {{plano.name}}
                        </div>
                        <div v-else style="height: 52px;" class="boleto">
                            <span ><p></p></span>
                            <i class="fas fa-barcode"></i>
                            {{plano.name}}
                            </div>
                        <a @click="contratoPF(plano)" class="button">Contratar plano</a>
                    </div>
                </div>
                </v-flex>            
            </v-layout>
        </v-container>        
    </div>
    </div>
    </v-fade-transition>
</div>
</section>
<v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) cliente,</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#00B21E">Oral Santa Helena</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#00B21E">Termo de Privacidade, <a href="https://Oral Santa Helena.intelite.com.br/contratosOral Santa Helena/docs/Politica_de_Privacidade_Oral Santa Helena_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#00B21E"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da Oral Santa Helena.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn @click="confirmaPlano()" color="#00B21E" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>

<script>
import Snackbar from '../components/snackbar.vue'
import axios from 'axios'
import { baseApiUrl } from '@/global'
export default {
    components: {Snackbar},
data(){
        return{
            dialog: false,
            abrangenciaAgrupamento: '',
            exibeLocalizacao: true,
            nomeAgrupamento: '',
            planos: [],
            vendedor: [],
            planoSelecionado: [],
            abrangencias: [],
            agrupamentosUF: [],
            abrangenciaUF: '',
            contrataccept: false
    };
  },
 /*  watch: {
    'estado': function () {
      this.cidades = brasil[this.estado].cidades
    }
  }, */
    
    mounted : function(){    
      localStorage.clear()
      sessionStorage.clear()  
      this.pegaParametrosUrl()  
      this.$store.dispatch('ExibeToolbar')
      this.$store.dispatch('ExibeFooter')
      this.exibeLocalizacao = true;
      this.$store.dispatch('Logar')
      this.carregaAgrupametos()
    },
    methods: {
        scrollToClass(className) {
            // Get the first element with the given class name
            let el = this.$el.querySelector(className)
            // Get the bounding rectangle so we can get the element position position
            let rect = el.getBoundingClientRect()
            // Scroll to the element (using x and y axis)
            window.scrollTo(rect.left, rect.top)
            },
            scrollbotton(){
            window.scrollTo(0, 3000)
        },
        async controlaExibicaoPlanos(){
            if(this.abrangenciaAgrupamento == '')
            {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#F9A825","Selecione o local onde deseja utililzar o plano.","ATENÇÃO")
            }
            else{
                for(var i=0; i<this.agrupamentosUF.length; i++) {
                    if(this.agrupamentosUF[i].abrangenciaId === this.abrangenciaAgrupamento) {
                        this.nomeAgrupamento = this.agrupamentosUF[i].agrupamento
                    }
                }
/*             if(this.nomeAgrupamento.includes("SP") || this.nomeAgrupamento.includes("MG") || this.nomeAgrupamento.includes("RO"))
            {
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#0288D1","Disponível em breve!","INFORMAÇÃO")
                return
            }    
            else{ */
            await axios.get(`${baseApiUrl}Plans?filter={"where":{"and":[{"abrangenciaId":{"inq":["${this.abrangenciaAgrupamento}"]}},{"qualificacao":{"inq":["Individual","Familiar"]}},{"visibility":{"inq":["TODOS","EXTERNA"]}},{"publico":"Pessoa Física"},{"ativo":{"neq":false}}]}}`).then(res => {        
            if(res.data != null){      
            this.planos = res.data   
            }              	
			})    
            this.exibeLocalizacao = false;
            }
            
        
        },
        /* contratoPF(plano){
            this.dialog = true
            
        }, */
        contratoPF(plano){

            localStorage.clear()
            sessionStorage.clear()
            this.planoSelecionado = plano
            this.$store.dispatch('planosPF', this.planoSelecionado)
            localStorage.setItem('planoSelecionado',JSON.stringify(this.planoSelecionado))   
            if(this.vendedor != '')
            sessionStorage.setItem('Vendedor',JSON.stringify(this.vendedor))        
            this.$router.push({ path: '/contratopf' })

        },
        calculaDesconto(plano){
            var desconto = parseFloat(plano.oldValue.replace(',', '.')) - parseFloat(plano.value.replace(',', '.'))
            //desconto = desconto.replace('.','.')
            return desconto.toFixed(2).replace('.',',')
        },
        async carregaAgrupametos(){
        this.abrangenciaOrgao = ''
        await axios.get(`${baseApiUrl}AgrupamentoUFs?filter={"where":{"and":[{"status":"Ativo"},{"tipo":"PF"}]}}`).then(res => {        
            if(res.data != null){      
            this.agrupamentosUF = res.data.sort(this.compare)
            }
        })

        },
        compare(a, b) {
        // Use toUpperCase() to ignore character casing
        const agrupamentoA = a.agrupamento;
        const agrupamentoB = b.agrupamento;

        let comparison = 0;
        if (agrupamentoA > agrupamentoB) {
            comparison = 1;
        } else if (agrupamentoA < agrupamentoB) {
            comparison = -1;
        }
        return comparison;
        },
    async pegaParametrosUrl(){
      var params = window.location.search.substring(1).split('&');
      if(params[0] != ''){
      //Criar objeto que vai conter os parametros
      var paramArray = {};

      //Passar por todos os parametros
      for(var i=0; i<params.length; i++) {
          //Dividir os parametros chave e valor
          var param = params[i].split('=');

          //Adicionar ao objeto criado antes
          paramArray[param[0]] = param[1];
          }      
      if(paramArray['vendedor'])
      {
      await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor']}`).then(res => {        
            if(res.data != null){
            //console.log(res.data[0])
            this.vendedor = res.data[0]           
            }              	
			}) 
        }
      }
    }
    }
}
</script>

<style>

    .localizacao{
        border: 1px solid;
        border-color: #00B21E;
    }
</style>
